import React from 'react';
import { number, bool, string, func } from 'prop-types';
import cx from 'classnames';
import useStyles from 'hooks/useStyles';

import { MaterialIcon, LockIcon } from 'components/Icon';
import styles from './MaterialButton.scss';

function MaterialButton({
  title,
  isDisabled,
  onClick,
  className,
  file,
  id,
  ordinalNumber,
}) {
  useStyles(styles);

  return (
    <div
      className={cx(styles.root, { [styles.disabled]: isDisabled }, className)}
      onClick={onClick({ file, id, title, ordinalNumber })}
    >
      <MaterialIcon className={cx(styles.materialIcon, styles.icon)} />
      <span className={styles.title}> {title} </span>
      {isDisabled && <LockIcon className={styles.icon} />}
    </div>
  );
}

MaterialButton.propTypes = {
  title: string.isRequired,
  file: string.isRequired,
  id: number.isRequired,
  ordinalNumber: number.isRequired,
  onClick: func.isRequired,
  isDisabled: bool.isRequired,
  className: string,
};

MaterialButton.defaultProps = {
  className: '',
};

export default MaterialButton;
